import {searchModel} from './search';

export function batchModel(data) {
    if (!Array.isArray(data.batchItems)) {
        return null;
    }

    data.batchItems = data.batchItems.map((batchItem) => {
        if (batchItem.response.error) {
            return { error: batchItem.response.error};
        } else {
            return searchModel(batchItem.response);
        }
    });

    return data;
}
